export const formatLabelWithCode = (name?: string, code?: string): string => {
  if (name && code) {
    return `${name} (${code})`;
  }

  if (name) {
    return name;
  }

  if (code) {
    return code;
  }

  return 'N/A';
};

